import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Stepper, Step, StepLabel, Fade, Grow } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { colors, Typography } from 'kangarootime-ui';
import moment from 'moment';
import './RoomAssignments.css';

const styles = theme => ({
  root: {
    color: theme.palette.text.disabled,
    '&$active': {
      color: colors.mayaBlue
    },
    '&$completed': {
      color: colors.mayaBlue
    }
  },
  active: {},
  completed: {}
});

const RoomAssigments = ({ assignments, activeAssignmentIndex, ...props }) => {
  const formatTime = date => moment(date).format('h:mm A');

  return (
    <Fragment>
      { assignments && assignments.length > 0
        ? <Grow in>
          <Stepper activeStep={activeAssignmentIndex}>
            { assignments.map((assignment, index) => (
              <Step key={index}>
                <StepLabel
                  className='stepper-main-label'
                  StepIconProps={{ classes: props.classes }}
                  optional={<span className='stepper-time-label'>{formatTime(assignment.start)} - {formatTime(assignment.end)}</span>}
                >{assignment.roomName}</StepLabel>
              </Step>
            ))}
          </Stepper>
        </Grow>
        : <Fade in>
          <Typography type='meta'>Not Scheduled</Typography>
        </Fade>
      }
    </Fragment>
  );
};

RoomAssigments.propTypes = {
  assignments: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    roomName: PropTypes.string,
    start: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    end: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)])
  })),
  activeAssignmentIndex: PropTypes.number
};

export default withStyles(styles)(RoomAssigments);
